import _toConsumableArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { isFluid as isBoxShadowFluid, parse as parseBoxShadow, stringify as convertBoxShadow } from './boxShadow';
import normalizeBreakpointsArray from './normalizeBreakpointsArray';

/**
 * List of css properties that need to be converted to vw units
 */
var fluidProps = ['padding', 'margin', 'paddingLeft', 'marginLeft', 'paddingRight', 'marginRight', 'paddingBottom', 'marginBottom', 'paddingTop', 'marginTop', 'width', 'minWidth', 'maxWidth', 'height', 'maxHeight', 'borderRadius', 'top', 'right', 'bottom', 'left', 'fontSize', 'lineHeight', 'letterSpacing', 'gap', 'rowGap', 'columnGap', 'gridGap', 'gridRowGap', 'gridColumnGap', 'gridAutoRows', 'flexBasis', 'outlineOffset', 'outlineWidth', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'marginInlineEnd', 'marginInlineStart'];
var colorProps = ['background', 'backgroundColor', 'color', 'borderColor', 'fill', 'stroke'];

var isFluidProp = function isFluidProp(key, value) {
  return fluidProps.includes(key) && value !== null && value !== undefined && !isNaN(value) && value != 0;
};

var fallbackMultiplier = function fallbackMultiplier(value) {
  return "".concat(value, "px");
};

var normalizeValue = function normalizeValue(key, value, theme, media) {
  // Support color tokens
  if (colorProps.includes(key)) {
    return theme.colors[value] || value;
  }

  if (isFluidProp(key, value)) {
    return getMultiplier(theme, media)(value);
  }

  if (key === 'boxShadow' && value) {
    var options = parseBoxShadow(value);
    return convertBoxShadow(options, getMultiplier(theme, media));
  }

  return value;
};

var getMultiplier = function getMultiplier(theme, media) {
  return theme.disableScaling || !media ? fallbackMultiplier : theme.multipliers[media] || fallbackMultiplier;
};

function convertToBreakpoints(values, theme, media) {
  var rules = {};

  var writeRule = function writeRule(key, value, media) {
    if (value === null || value === undefined) {
      return;
    }

    if (!media) {
      rules[key] = normalizeValue(key, value, theme, media);
    } else {
      var mediaQuery = "@media ".concat(theme.mediaQueries[media]);

      if (typeof rules[mediaQuery] === 'undefined') {
        rules[mediaQuery] = {};
      }

      var rule = rules[mediaQuery] || {};
      rule[key] = normalizeValue(key, value, theme, media);
    }
  };

  Object.entries(values).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (Object.prototype.toString.call(val) === '[object Object]') {
      rules[key] = convertToBreakpoints(val, theme);
      return;
    }

    var cleanValue = val;

    if (Array.isArray(val)) {
      cleanValue = normalizeBreakpointsArray(val, theme);
    } else if (isFluidProp(key, val)) {
      // If number is passed it's a fluid prop than convert to breakpoints with single value
      cleanValue = _toConsumableArray(new Array(theme.viewportsArray.length)).map(function () {
        return val;
      });
    } else if (key === 'boxShadow' && typeof val === 'string' && isBoxShadowFluid(val)) {
      cleanValue = _toConsumableArray(new Array(theme.viewportsArray.length)).map(function () {
        return val;
      });
    }

    if (media) {
      var mediaQuery = theme.mediaQueries[media];
      var arrIndex = theme.viewportsArray.indexOf(media);

      if (!mediaQuery || arrIndex === -1) {
        // eslint-disable-next-line no-console
        console.warn('Invalid media query passed to normalizedStyles', media);
        return;
      }

      writeRule(key, Array.isArray(val) ? val[arrIndex] : val, media);
    } else if (Array.isArray(cleanValue)) {
      cleanValue.forEach(function (val, i) {
        writeRule(key, val, theme.viewportsArray[i]);
      });
    } else {
      writeRule(key, cleanValue);
    }
  });
  return rules;
}

var normalizeStyles = function normalizeStyles(values, media) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return values ? convertToBreakpoints(values, theme, media) : null;
  };
};

export default normalizeStyles;